import React, { Component, Fragment } from 'react'
import LoggedSidebar from 'App/Shell/LoggedSidebar'
import PropTypes from 'prop-types'
import { Alert } from 'loyal-react'
import { PasswordBox } from './PasswordBox'
import { PasswordConfirmBox } from './PasswordConfirmBox'
import { ConfirmTokenBox } from './ConfirmTokenBox'
import Auth from '@aws-amplify/auth'

const errors = {
  InternalErrorException: 'Erro ao validar o token. Tente novamente!',
  ErrorToken: 'Erro ao enviar o token. Tente novamente!',
  ErrorCheckPassword: 'Senha não segue os requisitos.',
  ErrorNotMatch: 'Senhas não conferem.'
}

const successMsg = {
  SuccessToken: 'Token enviado com sucesso.',
  SuccessConfirm: 'senha alterada com sucesso.'
}

const timerDefault = 180

class ChangeUraPassword extends Component {
  constructor (props) {
    super(props)
    this.state = {
      documentNumber: this.props.userInfo.username,
      email: this.props.userInfo.email,
      maskedEmail: '',
      password: '',
      passwordConfirm: '',
      token: '',
      isValidpassword: false,
      isValid: false,
      disableVerifyInput: false,
      disableVerifyButton: false,
      isLoadingToken: false,
      expiredTime: false,
      timeLeft: timerDefault,
      isLoading: false,
      passwordPage: true,
      passwordConfirmPage: false,
      confirmTokenPage: false
    }
    this.onChangePassword = this.onChangePassword.bind(this)
    this.onValidatePassword = this.onValidatePassword.bind(this)

    this.onChangePasswordConfirm = this.onChangePasswordConfirm.bind(this)
    this.onValidatePasswordConfirm = this.onValidatePasswordConfirm.bind(this)

    this.onChangeToken = this.onChangeToken.bind(this)
    this.toSeconds = this.toSeconds.bind(this)
    this.sendTokenAgain = this.sendTokenAgain.bind(this)
    this.confirmToken = this.confirmToken.bind(this)

    this.maskEmail = this.maskEmail.bind(this)
  }

  countDown () {
    this.setState({ timeLeft: this.state.timeLeft - 1 })
    if (this.state.timeLeft === 0) {
      clearInterval(this.state.timer)
      this.setState({ expiredTime: true })
    }
  }

  startTimer = () => {
    this.setState({
      timer: setInterval(() => {
        this.countDown()
      }, 1000)
    })
  }

  toSeconds = seconds => {
    return [parseInt((seconds / 60) % 60), parseInt(seconds % 60)]
      .join(':')
      .replace(/\b(\d)\b/g, '0$1')
  }

  componentDidMount () {
    const userPoolId = process.env.REACT_APP_NUM_USER_POOL_ID
    const region = process.env.REACT_APP_REGION
    const userPoolWebClientId = process.env.REACT_APP_NUM_CLIENT_ID

    Auth.configure({ userPoolId, userPoolWebClientId, region })

    this.setState({
      loadingPage: false,
      maskedEmail: this.maskEmail()
    })
  }

  onChangePassword = value => {
    this.setState({ password: `${value}`.replace(/\D/g, '') }, () =>
      this.isValid(value)
    )
  }

  onValidatePassword = () => {
    this.closeAlert()
    this.setState({
      isLoading: true
    })

    const handleSuccess = response => {
      setTimeout(() => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.data
        ) {
          this.setState({
            passwordPage: false,
            passwordConfirmPage: true
          })
        } else {
          this.setState({
            error: { msg: errors.ErrorCheckPassword },
            password: ''
          })
        }
        this.setState({
          isValid: false,
          isLoading: false
        })
      }, 500)
    }
    const { password } = this.state

    this.props.fetchCheckPassword(password).then(handleSuccess)
  }

  onChangePasswordConfirm = value => {
    this.setState({ passwordConfirm: `${value}`.replace(/\D/g, '') }, () =>
      this.isValid(value)
    )
  }

  onValidatePasswordConfirm = () => {
    this.closeAlert()
    this.setState({
      isLoading: true
    })
    const { passwordConfirm, password } = this.state
    if (passwordConfirm === password) {
      this.setState({
        passwordConfirmPage: false,
        confirmTokenPage: true
      })
      this.sendToken()
      this.startTimer()
    } else {
      this.setState({
        error: { msg: errors.ErrorNotMatch },
        passwordConfirm: ''
      })
    }
    this.setState({
      isValid: false,
      isLoading: false
    })
  }

  onChangeToken = value => {
    this.setState({ token: `${value}`.replace(/\D/g, '') }, () =>
      this.isValid(value)
    )
  }

  isValid = num => {
    let isValid = false
    const tokenValidator = /^[0-9]{6}$/
    const numero = num
    if (!tokenValidator.test(numero)) {
      isValid = false
    } else {
      isValid = true
    }
    this.setState({ isValid })
  }

  sendToken = () => {
    this.setState({
      isLoading: true
    })

    const handleSuccess = () => {
      this.setState({
        isLoading: false
      })
    }

    const handleError = () => {
      this.setState({
        isLoading: false,
        error: { msg: errors.ErrorToken }
      })
    }

    const { documentNumber } = this.state
    Auth.forgotPassword(documentNumber)
      .then(handleSuccess)
      .catch(handleError)
  }

  sendTokenAgain = () => {
    this.closeAlert()
    this.setState({
      isLoadingToken: true
    })

    const handleSuccess = () => {
      setTimeout(() => {
        this.setState({
          isLoadingToken: false,
          timeLeft: timerDefault,
          expiredTime: false,
          success: { msg: successMsg.SuccessToken }
        })
        this.startTimer()
      }, 300)
    }

    const handleError = () => {
      setTimeout(() => {
        this.setState({
          isLoadingToken: false,
          expiredTime: true,
          error: { msg: errors.ErrorToken }
        })
      }, 300)
    }

    const { documentNumber } = this.state
    Auth.forgotPassword(documentNumber)
      .then(handleSuccess)
      .catch(handleError)
  }

  confirmToken = () => {
    this.closeAlert()

    this.setState({
      isLoading: true
    })

    const handleSuccess = response => {
      if (response && response.type === 'FETCH_CHANGE_URA_PASS_SUCCESS') {
        this.setState({
          token: '',
          isValid: false,
          isLoading: false,
          disableVerifyInput: true,
          success: { msg: successMsg.SuccessConfirm }
        })
        setTimeout(() => {
          this.redirect()
        }, 3000)
      } else {
        this.setState({
          token: '',
          isValid: false,
          isLoading: false,
          error: { msg: errors.InternalErrorException }
        })
      }
    }
    const handleError = () => {
      setTimeout(() => {
        this.setState({
          token: '',
          isValid: false,
          isLoading: false,
          error: { msg: errors.InternalErrorException }
        })
      }, 300)
    }

    const { token: cognitoToken, password: passwordNumber } = this.state
    this.props
      .fetchChangeUraPass({
        passwordNumber,
        cognitoToken
      })
      .then(handleSuccess)
      .catch(handleError)
  }

  redirect () {
    this.props.history.push('/security-access')
  }

  maskEmail = () => {
    let email = this.state.email
    let maskedEmail = ''
    let idx = 0
    let arroba = email.indexOf('@')
    for (let e of email) {
      if (idx >= 4 && idx < arroba) {
        maskedEmail += '*'
      } else {
        maskedEmail += e
      }
      idx++
    }
    return maskedEmail
  }

  closeAlert = () => this.setState({ error: null, success: null })

  render () {
    return (
      <Fragment>
        <div className='container-fluid px-0 bg-ui-4'>
          <div className='container py-4'>
            <div className='row'>
              <LoggedSidebar selected={this.props.location.pathname} />
              <div className='col-12 col-xl-8 mt-0'>
                {this.state.error && (
                  <Alert
                    isError
                    title={this.state.error.msg}
                    className='pb-2'
                    onClose={this.closeAlert}
                  />
                )}
                {this.state.success && (
                  <Alert
                    title={this.state.success.msg}
                    className='pb-2'
                    onClose={this.closeAlert}
                  />
                )}
                {this.state.passwordPage ? (
                  <PasswordBox
                    {...this.state}
                    onChangePassword={this.onChangePassword}
                    onValidatePassword={this.onValidatePassword}
                  />
                ) : (
                  ''
                )}
                {this.state.passwordConfirmPage ? (
                  <PasswordConfirmBox
                    {...this.state}
                    onChangePasswordConfirm={this.onChangePasswordConfirm}
                    onValidatePasswordConfirm={this.onValidatePasswordConfirm}
                  />
                ) : (
                  ''
                )}
                {this.state.confirmTokenPage ? (
                  <ConfirmTokenBox
                    {...this.state}
                    onChangeToken={this.onChangeToken}
                    toSeconds={this.toSeconds}
                    sendTokenAgain={this.sendTokenAgain}
                    confirmToken={this.confirmToken}
                  />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

ChangeUraPassword.propTypes = {
  userInfo: PropTypes.object,
  location: PropTypes.object.isRequired,
  fetchCheckPassword: PropTypes.func.isRequired,
  fetchChangeUraPass: PropTypes.func.isRequired,
  history: PropTypes.object
}

export default ChangeUraPassword



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/ChangeUraPassword/ChangeUraPassword.js